module.exports = __webpack_public_path__ + "img/photo-50.350eff01.webp";